import { connect } from 'react-redux'
import { preferencesActions, notifyActions } from '../store/actions';
import pageWhiteList from './pages/whitelist';

const mapStateToProps = state => {
    return {
        ...state,
        preferences: state.preferences,
        role: state.role,
        user: state.user
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        sendEditPreferences: (id, data) => {
            dispatch(preferencesActions.sendEditPreferences(id, data))
        },
        deleteKeyFromList: (id, key) => {
            dispatch(preferencesActions.deleteKeyFromList(id, key))
        },
        successNotify: (message) => {
            dispatch(notifyActions.successAction(message))
        },
        warningNotify: (message) => {
            dispatch(notifyActions.warningAction(message))
        },
        errorNotify: (message) => {
            dispatch(notifyActions.errorAction(message))
        },
        infoNotify: (message) => {
            dispatch(notifyActions.infoAction(message))
        },
        flush: () => {
            dispatch(preferencesActions.flush())
        },
        flushConfig: () => {
            dispatch(preferencesActions.flushConfig())
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(pageWhiteList);